(function($) {

	$.fn.filterui = function(options) {
		var elem = $(this),
			activeStateClass = 'is-active',
			$checkboxElements = $('.filter__option__input'),
			$checkedCheckboxElements = $('.filter__option__input:checked'),
			$filterSubmitButton = $('.filter__button-apply');

		var init = function() {
			$checkboxElements.on('change', function() {
				if ($($checkedCheckboxElements.selector).length > 0) {
					$filterSubmitButton.addClass(activeStateClass);
				} else {
					$filterSubmitButton.removeClass(activeStateClass);
				}
			});
		};

		init();
		return this;
	};

}($));
